import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip as ChartTooltipHost, LabelList, ResponsiveContainer,
} from 'recharts';
import DashboardCard from './DashboardCard';
import ChartTooltip from './ChartTooltip';
import { SERIES, GRID, CARD_IDS } from '../constants';
import { formatNumber } from '../format';

// Geç Kalma Süresi Dağılımı: tek seri (lejant yok — başlık adlandırır); her değer çubuğun üstünde yazılı (tablo
// gerekmez).
export default function LateDistributionCard({ slice }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const buckets = (slice.data?.buckets || []).map((b) => ({
    ...b,
    label: t('attendanceDashboard.lateDistribution.bucket', { range: b.key.replace('-', '–') }),
  }));
  const hasAny = buckets.some((b) => b.count > 0);

  return (
    <DashboardCard
      cardKey="gec-kalma-dagilimi"
      title={t('attendanceDashboard.lateDistribution.title')}
      span={4}
      spanMd={6}
      slice={slice}
      empty={!hasAny}
      domId={CARD_IDS.lateDistribution}
    >
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={buckets} margin={{ top: 18, right: 4, bottom: 0, left: 4 }}>
          <XAxis dataKey="label" tickLine={false} axisLine={{ stroke: GRID }} tick={{ fontSize: 11, fill: '#6B7280' }} />
          <YAxis hide allowDecimals={false} />
          <ChartTooltipHost
            cursor={{ fill: 'rgba(2, 145, 239, 0.05)' }}
            content={({ active, payload }) => {
              if (!active || !payload || payload.length === 0) return null;
              const b = payload[0].payload;
              return (
                <ChartTooltip
                  title={b.label}
                  rows={[{
                    key: b.key, color: SERIES.late, kind: 'box',
                    value: t('attendanceDashboard.lateDistribution.count', { count: b.count }), label: '',
                  }]}
                />
              );
            }}
          />
          <Bar dataKey="count" fill={SERIES.late} barSize={24} radius={[4, 4, 0, 0]} isAnimationActive={false}>
            <LabelList dataKey="count" position="top" formatter={(v) => formatNumber(v, lang)} style={{ fontSize: 11, fill: '#374151' }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
